import axios from "../axios-auth";
import orginal_axios from "axios";

export const creditCashFlowService = {
  save,
  printCreditCashFlowInvoice,
  showWindowDialog
};

function save(creditCashFlow) {
  return axios.post("auth/credit-cash-flow", creditCashFlow);
}

function printCreditCashFlowInvoice(id, isSaleFlag) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/print-credit-cash-flow-invoice/" + id + "/" +isSaleFlag,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function showWindowDialog(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  var link = document.createElement(fileName);
  link.href = data;
  link.download = fileName + ".pdf";
  window.open(link.href, fileName, "width=500,height=500");

  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}
